import { connect } from 'react-redux';

import { IParentProps, Parent } from './index';
import { IState } from '../../store';
import { getParent } from '../../utils/offer_helpers';

type TStoreProps = Pick<IParentProps, 'agent' | 'businessShoppingCenter' | 'offer' | 'parent'>;
type TOwnProps = Pick<IParentProps, 'containerClassName'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    agent: state.offerData.agent,
    businessShoppingCenter: state.offerData.businessShoppingCenter,
    offer: state.offerData.offer,
    parent: getParent(state.offerData),
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ParentContainer = connect<TStoreProps, any, TOwnProps>(mapStateToProps)(Parent);
